'use strict'

const { pubdb } = Function('return this')();
const {
    $, next_tick, add_tooltip, iframe_dialog, date_berlin, path_root, display_pub,
    review_sortable, review_filter_years, echo, ajax_post, display_when_ready,
    status_call1, status_otf, window,
} = pubdb;
const { pub_sep, setTimeout, alert } = window;
const { short_fn, year } = pub_sep;


const PUB_TYPE_NAME = {
    'wissenschaftlicher_beitrag': 'Wiss. Beitrag',
    'buchautorenschaft': 'Buchautorenschaft',
    'buchbeitrag': 'Buchbeitrag',
    'buchherausgeberschaft': 'Buchhrsg.',
    'e_veroeffentlichung': 'Elektronisch',
    'hochschulschrift': 'HS-Schrift',
    'patentschrift': 'Patent',
    'poster': 'Poster',
    'rezension': 'Rezension',
    'rundfunk_fernseh_beitrag': 'Rundfunk',
    'vortrag': 'Vortrag',
    'zeitschriftenherausgeberschaft': 'Zeitschr.hrsg.',
    'pressespiegel': 'Pressespiegel',
};

function mk_check_tooltip (label, elem) {
    const old_tooltip = label.data('pubdb-tooltip');
    if (old_tooltip) {
        label.data('pubdb-tooltip', null);

        const { questionmark, hover } = old_tooltip;
        if (questionmark) {
            questionmark.remove();
        }
        if (hover) {
            hover.remove();
        }
    }

    if (elem) {
        const tt = `${(elem.reviewer || {}).account_name || '???'} am ${date_berlin(1, elem.review_ts)}`;
        next_tick(function () { add_tooltip(label, tt); });
    }
}

function add_one (dest, datum, index) {
    let { pub, checks, ele } = datum || {};
    let {
        done: check_done,
        doing: check_doing,
        aop: status_aop,
    } = checks || {};
    let { interne_bemerkungen, journal_bemerkung } = pub;

    function mk_check (elem, text, name) {
        const label = $('<label/>', {
            text,
            css: {
                display: 'block',
                margin: 0,
                fontWeight: 'normal',
            },
            prepend: $('<input/>', {
                type: 'checkbox',
                name: `cb_${name}_${pub.id}`,
                value: 'y',
                prop: { checked: !!elem },
            }),
        });
        mk_check_tooltip(label, elem);
        return label;
    }

    function get_and_rerender_got_sep_data (success, data) {
        if (!success) {
            echo('warn', 'Konnte Zeile nicht aktualisieren: ' + data);
            return;
        }

        // nonlocal tr
        const new_tr = add_one(null, data, index);
        tr.replaceWith(new_tr);
        tr = new_tr;
    }

    function get_and_rerender () {
        status_call1(pub.id, 'sep_data', [], get_and_rerender_got_sep_data);
    }

    const journal_bemerkung_a = (pub.journal && (+pub.journal.id > 0)) ? $('<a/>', {
        href: `${path_root}/journal/${pub.journal.id}/edit/?content_only#bemerkung`,
        target: '_blank',
        text: 'Journal',
        on: {
            click (ev) {
                ev.preventDefault();
                const { href } = this;
                iframe_dialog(href, 'Fachzeitschrift bearbeiten', null, get_and_rerender);
            },
        },
        css: journal_bemerkung ? {background:'#f0c0c0'} : {},
    }) : '×';
    if (journal_bemerkung_a && journal_bemerkung) {
        next_tick(function () { add_tooltip(journal_bemerkung_a, journal_bemerkung) });
    }

    const interne_bemerkungen_a = $('<a/>', {
        href: `${path_root}/pub/${pub.id}/edit/?content_only#interne_bemerkungen`,
        target: '_blank',
        text: 'Publikation',
        on: {
            click (ev) {
                ev.preventDefault();
                const { href } = this;
                iframe_dialog(href, 'Publikation bearbeiten', null, get_and_rerender);
            },
        },
        css: interne_bemerkungen ? {background:'#f0c0c0'} : {},
    });
    if (interne_bemerkungen) {
        next_tick(function () { add_tooltip(interne_bemerkungen_a, interne_bemerkungen) });
    }

    var td0 = $('<td/>', {
        css: {
            whiteSpace: 'nowrap',
            backgroundColor: (
                check_done ? '#c0f0c0' :
                status_aop ? '#f0f0b0' :
                'unset'
            ),
        },
        append: [
            mk_check(check_doing, ' In Bearbeitung', 'doing'),
            mk_check(check_done, ' Erledigt', 'done'),
            mk_check(status_aop, ' Ahead of Print', 'aop'),
            $('<small/>', { 'class': 'index', text: index+1 }),
            $('<div/>', {
                css: { 'float': 'right' },
                append: [
                    $('<small/>', { text: 'Bemerkungen: ' }),
                    '[', journal_bemerkung_a, '] [', interne_bemerkungen_a, ']',
                ],
            }),
        ],
    });

    let td1 = $('<td/>', {
        css: {
            maxWidth: '800px',
            overflowX: 'auto',
        },
    });
    display_pub([pub], td1);

    let td2 = $('<td/>', {
        text: new Date(pub.datum).getFullYear(),
    });

    let td3 = $('<td/>', {
        text: PUB_TYPE_NAME[pub.typ],
        append: (
            pub.subtype && pub.subtype !== '-'
            ? [$('<p/>'), pub.subtype]
            : []
        ),
    });

    let td4 = $('<td/>', {
        append: [
            'WE: ',
            pub.we && pub.we.real ? $('<abbr/>', {
                title: pub.we.name,
                text: pub.we.id,
            }) : $('<em/>', {
                css: { color: 'crimson' },
                text: 'Keine!',
            }),
            $('<p/>'),
            'Autoren: ',
        ]
    });
    let has_authors = 0;
    let span_authors = {};
    (pub.authors || []).forEach(function (author) {
        if (author.we_id) {
            const key = 1000 + author.we_id;
            if (!span_authors[key]) {
                span_authors[key] = $('<abbr/>', {
                    title: author.we,
                    text: author.we_id,
                });
                ++has_authors;
            }
        }
    });
    if (has_authors) {
        Object.keys(span_authors).sort().forEach(function (key, index) {
            if (index > 0) {
                td4.append(', ');
            }
            td4.append(span_authors[key]);
        });
    } else {
        $('<em/>', {
            css: { color: 'crimson' },
            text: 'Keine!',
            appendTo: td4,
        })
    }

    let td5;
    if (ele && ele.timestamp) {
        const del_ele_href = `${path_root}/pub/${pub.id}/del-review/ele/`;
        td5 = $('<td/>', { append: [
            $('<a/>', {
                href: path_root + '/log/' + ele.id + '/',
                target: '_blank',
                css: { whiteSpace: 'pre' },
                text: date_berlin(1, ele.timestamp).replace(/,? /g, '\n'),
            }),
            $('<br/>'),
            $('<a/>', {
                href: path_root + '/user/' + ele.user_id + '/',
                css: { fontWeight: 'bold' },
                target: '_blank', 
                text: ele.user_email,
            }),
            $('<hr/>'),
            $('<a/>', {
                href: del_ele_href,
                text: 'benötigt erneutes Review',
                on: {
                    click (ev) {
                        ev.preventDefault();
                        iframe_dialog(
                            `${del_ele_href}?content_only`,
                            'Markierung entfernen und ggf. interne Bemerkung ändern',
                            null,
                            get_and_rerender,
                        );
                    },
                },
            }),
        ] });
    } else if (ele === null) {
        td5 = $('<td/>')
    }

    let tr = $('<tr/>', {
        css: { backgroundColor: index%2 ? '#fff' : '#efefef' },
        append: [td0, td1, td2, td3, td4, td5],
    });
    if (dest) {
        tr.appendTo(dest);
    }
    return tr;
}


function got_json (response) {
    $('.container').css({
        margin: 0,
        padding: 0,
        maxWidth: 'unset',
    });

    if (!response || !response.success) {
        alert(':(');
        return;
    }

    setTimeout(function display (dest, data, index) {
        const { length } = data || [];
        if (index >= length) {
            review_sortable();
            review_filter_years(0, 3);
            return;
        }

        for (let count = 0; (count < 10) && (index < length); ++count) {
            add_one(dest, data[index], index++);
        }

        next_tick(function next () {
            display(dest, data, index);
        });
    }, 4, $('#pubdb_data').empty(), response.data, 0);
}


function get_otf_triple (cb, shall_check) {
    const split = (cb.attr('name') || '').split(/_/g);
    if ((split.length === 3) && (split[0] === 'cb')) {
        const [ /*cb*/, check, pub_id ] = split;
        const op = shall_check ? 'set_check' : 'del_check';
        return [+pub_id, op, [check]];
    }
}

function got_otf_result(cb, shall_check, data) {
    mk_check_tooltip(cb.closest('label'), data);
}

if (year !== null) {
    const fn = display_when_ready(got_json);
    ajax_post(`${path_root}/review/sep/${short_fn}/${year}.json`, Math.random(), fn, fn);

    status_otf(get_otf_triple, got_otf_result);
}
